import React from 'react';
import { Oval } from 'react-loader-spinner';

const OvalSpinner = ({ className, color, height, width, ...restProps }) => {
  return (
    <Oval
      height={height}
      width={width}
      color={color}
      wrapperStyle={{}}
      wrapperClass={className}
      visible={true}
      ariaLabel="oval-loading"
      secondaryColor={color}
      strokeWidth={2}
      strokeWidthSecondary={2}
      {...restProps}
    />
  );
};

OvalSpinner.defaultProps = { height: 15, width: 15, color: '#3F77AC' };

export default React.memo(OvalSpinner);
